
import React from 'react';
import FooterLogo from './footer/FooterLogo';
import FooterQuickLinks from './footer/FooterQuickLinks';
import FooterLegal from './footer/FooterLegal';
import FooterContact from './footer/FooterContact';
import { useNavigate } from 'react-router-dom';
import { Shield, Lock } from 'lucide-react';

const Footer = () => {
  const navigate = useNavigate();
  
  // Function to handle navigation with hash fragments
  const handleHashNavigation = (hash: string) => {
    navigate('/', { state: { noRedirect: true } });
    
    // Give the page time to load before scrolling
    setTimeout(() => {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <footer className="bg-nation-blue text-white pt-12 pb-6">
      <div className="container-full max-w-screen-2xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <FooterLogo />
          <FooterQuickLinks onNavigate={handleHashNavigation} />
          <FooterLegal />
          <FooterContact />
        </div>
        
        <div className="pt-6 mt-6 border-t border-gray-700 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            © {new Date().getFullYear()} NationCard™. All rights reserved.
          </p>
          
          <div className="flex items-center gap-3">
            {/* Privacy Shield Badge */}
            <div className="relative">
              <div className="flex items-center gap-2 bg-gradient-to-br from-green-500/20 to-green-600/30 px-4 py-2.5 rounded-lg border border-green-500/40 shadow-lg backdrop-blur-sm">
                <div className="relative">
                  <Shield className="h-5 w-5 text-green-300 drop-shadow-sm" />
                  <div className="absolute inset-0 bg-green-400/20 rounded-full blur-sm"></div>
                </div>
                <div className="flex flex-col">
                  <span className="text-green-200 text-xs font-semibold leading-tight">PRIVACY</span>
                  <span className="text-green-300 text-xs leading-tight">FOCUSED</span>
                </div>
              </div>
              {/* Shield glow effect */}
              <div className="absolute inset-0 bg-green-500/10 rounded-lg blur-md -z-10"></div>
            </div>
            
            {/* Security Shield Badge */}
            <div className="relative">
              <div className="flex items-center gap-2 bg-gradient-to-br from-blue-500/20 to-blue-600/30 px-4 py-2.5 rounded-lg border border-blue-500/40 shadow-lg backdrop-blur-sm">
                <div className="relative">
                  <Lock className="h-5 w-5 text-blue-300 drop-shadow-sm" />
                  <div className="absolute inset-0 bg-blue-400/20 rounded-full blur-sm"></div>
                </div>
                <div className="flex flex-col">
                  <span className="text-blue-200 text-xs font-semibold leading-tight">SSL</span>
                  <span className="text-blue-300 text-xs leading-tight">SECURED</span>
                </div>
              </div>
              {/* Shield glow effect */}
              <div className="absolute inset-0 bg-blue-500/10 rounded-lg blur-md -z-10"></div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
